import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';

function PDPGalleriesExtension() {
  const ref = useEsiPortal('esi-pdp-galleries');

  return <div ref={ref} />;
}

export default PDPGalleriesExtension;
